import {
  AppBar,
  Container,
  Toolbar,
  Typography,
} from "@mui/material";
import LogoPGJEM from "assets/images/logo_poder_judicial.png";

export const NavbarInvitado = () => {
  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters className="flex justify-center">
          <img
            src={LogoPGJEM}
            className="inline h-full max-w-full transition-all duration-200 ease-nav-brand max-h-8 px-3"
            alt="main_logo"
          />
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            Tribunal Electrónico
          </Typography>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
